import { useT } from '../../i18n';
import { Button } from './button';
import { Dialog } from './dialog';

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Spell out the consequence — destructive actions must never be a surprise. */
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
}

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  destructive = true,
  loading = false,
  onConfirm,
}: ConfirmDialogProps) => {
  const { t } = useT();

  return (
  <Dialog
    open={open}
    onOpenChange={onOpenChange}
    title={title}
    size="sm"
    footer={
      <>
        <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={loading}>
          {cancelLabel ?? t('common.cancel')}
        </Button>
        <Button
          variant={destructive ? 'danger' : 'primary'}
          onClick={onConfirm}
          loading={loading}
          autoFocus
        >
          {confirmLabel ?? t('common.confirm')}
        </Button>
      </>
    }
  >
    <p className="text-[13px] leading-relaxed text-ink-muted">{description}</p>
  </Dialog>
  );
};
